import React from "react";
import { Photo } from "./photo";

export function PhotoMobile() {
    return (
        <div className="artifact_group">
            <Photo />
        </div>
    );
}
